// extracted by mini-css-extract-plugin
export default {"label":"EllipsisLabel_label__mMcR1"};